import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  DevNote,
  FormFieldSet,
  LogoLoader,
  TableAdv,
  showToast,
  StatusTags,
  useFormHandler,
  SmartTooltip,
} from "../../../../components";
import qb from "../../../../assets/qb.svg";
import { getClientId, mapTableRows } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  qbApiStart,
  resetAllQBData,
} from "../../../../redux/slices/quickBooks/quickBooksSlice";
import {
  clearClientData,
  getClientsStart,
} from "../../../../redux/slices/client/clientSlice";
import { usePagination } from "../../../../hooks";
import axios from "axios";
import { WORKFORCE_API_URL } from "../../../../redux/apiConfig";
import QbAnimationLoading from "../../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";

const Clients = ({ setActiveTab, dropdowns }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, clients, totalCount } = useSelector(
    (state) => state.client
  );

  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const [qbLoading, setQbLoading] = useState(false);

  const isLoading = loading;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getClientsStart({
          page: newPage,
          limit: newLimit,
          filter: {},
          sort: { uiid: -1 },
          // sort: { uiid: 1 },
          ret: "",
          ref: "PlacementWithEmp",
          incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
        })
      );
    }
  );

  const tableData = clients?.data || [];
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Placement: "",
    documentType: "",
    status: "",
  });
  const columns = [
    {
      key: "businessname",
      label: "Business Name",
      width:"min-w-[300px] max-w-[350px]",
      render: (row) => (
        <SmartTooltip
          description={row.businessname}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
        <div className="flex items-center gap-3 group">
          <div
            className={`flex gap-2 items-center cursor-pointer ${
              row?.qbSync?.id
                ? "text-success"
                : row?.qbSync?.error
                ? "text-danger"
                : "text-linkblue"
            } `}
          >
            <Avatar
              alt={row.businessName}
              size="sm"
              contain
              src={row.profileImage}
            />
            <div className=" line-clamp-1!">{row.businessname}</div>
          </div>
        </div>
        </SmartTooltip>
      ),
      sortable: false,
    },

    {
      key: "businessUnit",
      label: "Business Unit",
      sortable: false,
    },

    {
      key: "clientid",
      label: "client Id",
      sortable: false,
    },
    {
      key: "netterms",
      label: "Net Terms",
      sortable: false,
    },
    {
      key: "terminitionNotice",
      label: "Terminiation Notice",
      sortable: false,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => <StatusTags tag={row.status} />,
      sortable: false,
    },
    {
      key: "comments",
      label: "Comments",
      sortable: false,
    },
    {
      key: "syncstatus",
      label: "Sync Status",
      render: (row) => <div>{row?.qbSync?.id ? "Synced" : "Unsynced"}</div>,
      sortable: false,
    },
  ];

  const rowdata = [
    {
      businessname: "ABC Corporation",
      businessUnit: "Tektree",
      clientid: "CLN-00123",
      netterms: "30 Days",
      terminitionNotice: "90 Days",
      status: "Active",
      comments: "Client has a long-term contract with quarterly review",
    },
    {
      businessname: "XYZ Solutions",
      businessUnit: "Tektree",
      clientid: "CLN-00456",
      netterms: "30 Days",
      terminitionNotice: "30 Days",
      status: "Inactive",
      comments: "Contract terminated due to non-compliance",
    },
    {
      businessname: "TechWave Inc",
      businessUnit: "Tektree",
      clientid: "CLN-00789",
      netterms: "45 Days",
      terminitionNotice: "90 Days",
      status: "Active",
      comments: "Awaiting renewal confirmation",
    },
  ];
  const fetchClientsData = async () => {
    dispatch(
      qbApiStart({
        method: "GET",
        entity: "customers",
        // body: {
        //
        // },
      })
    );
  };
  // useEffect(() => {
  //   fetchClientsData();
  // }, []);

  useEffect(() => {
    dispatch(
      getClientsStart({
        page: page,
        limit: limit,
        filter: {},
        sort: { uiid: -1 },
        // sort: { uiid: 1 },
        ret: "",
        ref: "PlacementWithEmp",
        incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate jobInfo.jobCode",
      })
    );
    return () => {
      dispatch(clearClientData());
    };
  }, [dispatch, page, limit, forceRerenderKey]);

  const rowData2 =
    tableData?.map((data) => ({
      id: data?.uiid,
      qbSync: data?.qbSync,
      businessname: data?.businessName || "-",
      businessUnit: "-",
      // clientid: "CLN-00123",
      clientid: getClientId(data?.uiid) || "-",
      // netterms: "30 Days",
      netterms:
        data?.generalInfo?.recurring?.netTerms ||
        data?.generalInfo?.permanent?.netTerms ||
        "-",
      // terminitionNotice: "90 Days",
      terminitionNotice:
        data?.generalInfo?.recurring?.jobTerminationNotice || "-",
      status: data?.recordStatus === 1 ? "Active" : "Inactive" || "-",
      // comments: "Client has a long-term contract with quarterly review",
      comments: data?.additionalInfo || "-",
    })) || [];
  const mappedRows = mapTableRows(rowData2, columns);
  // const mappedRows = mapTableRows(rowdata, columns);
  const handleSearch = () => {
    setActiveTab(Number(formData.Timesheets));
  };

  const forceRerender = () => {
    setForceRerenderKey((prevKey) => prevKey + 1);
  };
  //working
  // const handleUpdate = async (entity) => {
  //   if (selectedRowIds.length === 0) {
  //     showToast("Please select at least one invoice", "info", 5000);
  //     return;
  //   }
  //   let baseUrl = WORKFORCE_API_URL;
  //   let successCount = 0;
  //   let failedCount = 0;
  //   try {
  //     setQbLoading(true);

  //     const selectedIds = selectedRowIds;
  //     const clientDataFilter = tableData?.filter((invoice) =>
  //       selectedIds.includes(invoice.uiid)
  //     );

  //     const buildClientPayload = (data) => ({
  //       postActions: ["AddQBToClient"],
  //       payload: {
  //         qbSync: data?.qbSync || null,
  //         businessName: (data.businessName || "").replace(/[^\w\s]/g, ""),
  //         uiid: data.uiid || null,
  //         email: data.email || [],
  //         phone:
  //           data.phone && data.phone.length > 0
  //             ? data.phone.map((p) => ({
  //                 code: p.code || undefined,
  //                 number: String(p.number || undefined),
  //               }))
  //             : [{ code: undefined, number: undefined }],
  //         roleContacts:
  //           data.roleContacts && data.roleContacts.length > 0
  //             ? data.roleContacts.map((rc) => ({
  //                 role: rc.role || "",
  //                 email: rc.email || [],
  //                 phone:
  //                   rc.phone && rc.phone.length > 0
  //                     ? rc.phone.map((p) => ({
  //                         code: p.code || "",
  //                         number: String(p.number || ""),
  //                       }))
  //                     : [],
  //               }))
  //             : [],
  //         federalId: data.federalId || "",
  //         website: data.website || "",
  //         recordStatus: data.recordStatus || null,
  //         ownership: data.ownership || null,
  //         generalInfo: {
  //           currencyType: 1 || null,
  //           placementDetails: {
  //             recurring: {
  //               netTerms: data.generalInfo?.recurring?.netTerms || "",
  //               category: "",
  //               jobTerminationNotice: null,
  //             },
  //           },
  //           locations: (data.generalInfo?.locations || []).map((loc) => ({
  //             street: loc.street || "",
  //             address1: loc.address1 || "",
  //             address2: loc.address2 || "",
  //             city: loc.city || "",
  //             state: loc.state || "",
  //             zipCode: loc.zipCode ?? null,
  //             country: loc.country || "",
  //             isDefaultInvoice: loc.isDefaultInvoice || false,
  //           })),
  //         },
  //         contacts: data.contacts || [],
  //         additionalInfo: data.additionalInfo || "",
  //         documents: (data.documents || []).map((doc) => ({
  //           placement: doc.placement || [],
  //           list: doc.list || [],
  //         })),
  //         placements: data.placements || [],
  //         addedBy: data.addedBy || null,
  //         addedOn: data.addedOn || new Date().toISOString(),
  //       },
  //     });

  //     for (const client of clientDataFilter) {
  //       const clientData = client || {};
  //       const isClientSynced = Boolean(clientData?.qbSync?.id);

  //       if (!isClientSynced) {
  //         try {
  //           const clientPayload = buildClientPayload(clientData);
  //           await axios.post(`${baseUrl}/qb/customers`, clientPayload, {
  //             headers: { "Content-Type": "application/json" },
  //             withCredentials: true,
  //           });
  //           successCount++;
  //         } catch (err) {
  //           console.error("Customer Sync Failed:", err.response || err);
  //           failedCount++;
  //         }
  //       } else {
  //         try {
  //           const clientPayload = buildClientPayload(clientData);
  //           await axios.post(`${baseUrl}/qb/customers`, {
  //             update: true,
  //             ...clientPayload
  //           }, {
  //             headers: { "Content-Type": "application/json" },
  //             withCredentials: true,
  //           });
  //           successCount++;
  //         } catch (err) {
  //           console.error("Customer Sync Failed:", err.response || err);
  //           failedCount++;
  //         }
  //       }
  //     }
  //   } catch (e) {
  //     console.error("Unexpected Error in Sync", e);
  //   } finally {
  //     setQbLoading(false);
  //     forceRerender();
  //     showToast(
  //       `QB Sync Completed: ${successCount} succeeded, ${failedCount} failed.`,
  //       failedCount > 0 ? "warning" : "success",
  //       6000
  //     );
  //   }
  // };
  //testing
  const handleUpdate = async (entity) => {
    if (selectedRowIds.length === 0) {
      showToast("Please select at least one invoice", "info", 5000);
      return;
    }

    let baseUrl = WORKFORCE_API_URL;
    setQbLoading(true);

    const selectedIds = selectedRowIds;
    const clientDataFilter = tableData?.filter((invoice) =>
      selectedIds.includes(invoice.uiid)
    );

    const axiosConfig = {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    };

    const buildClientPayload = (data, isUpdate = false) => ({
      ...(isUpdate && { update: true }),
      postActions: ["AddQBToClient"],
      payload: {
        qbSync: data?.qbSync || null,
        // businessName: data.businessName || "",
        businessName: data?.businessName || "",
        uiid: data?.uiid || null,
        email: data?.email || [],
        phone: (data?.phone || []).map((p) => ({
          code: p.code || "",
          number: String(p.number || ""),
        })),
        roleContacts: (data?.roleContacts || []).map((rc) => ({
          role: rc.role || "",
          email: rc.email || [],
          phone: (rc.phone || []).map((p) => ({
            code: p.code || "",
            number: String(p.number || ""),
          })),
        })),
        federalId: data?.federalId || "",
        website: data?.website || "",
        recordStatus: data?.recordStatus || null,
        ownership: data?.ownership || null,
        generalInfo: data?.generalInfo || null,
        contacts: data?.contacts || [],
        additionalInfo: data?.additionalInfo || "",
        documents: (data?.documents || []).map((doc) => ({
          placement: doc.placement || [],
          list: doc.list || [],
        })),
        placements: data?.placements || [],
        addedBy: data?.addedBy || null,
        addedOn: data?.addedOn || new Date().toISOString(),
      },
    });

    const results = await Promise.allSettled(
      clientDataFilter.map(async (clientData) => {
        const isSynced = Boolean(clientData?.qbSync?.id);
        const payload = buildClientPayload(clientData, isSynced);
        try {
          await axios.post(`${baseUrl}/qb/customers`, payload, axiosConfig);
          return "success";
        } catch (err) {
          showToast(
            `${err?.response?.data?.error || "Unknown error"}`,
            "warning",
            10000
          );
          console.error("Customer Sync Failed:", err.response || err);
          return "fail";
        }
      })
    );

    const successCount = results.filter(
      (r) => r.status === "fulfilled" && r.value === "success"
    ).length;
    const failedCount = results.length - successCount;

    setQbLoading(false);
    forceRerender();
    showToast(
      `QB Sync Completed: ${successCount} succeeded, ${failedCount} failed.`,
      failedCount > 0 ? "warning" : "success",
      6000
    );
  };

  return (
    <div className="flex flex-col overflow-hidden">
      <QbAnimationLoading
        isOpen={qbLoading}
        onClose={() => setQbLoading(false)}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
      <TableAdv
        tableId={"invoices_qbintegration_clients"}
        defaultSelectedRows={selectedRowIds}
        onSelectionChange={(ids) => setSelectedRowIds(ids)}
        rows={mappedRows}
        columns={columns}
        // limit={100}
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        showCheckbox
        toolbarRight={{
          search: false,
          filter: false,
          download: false,
          add: [
            {
              component: (
                <div className=" flex flex-wrap items-center gap-3 m-2">
                  <FormFieldSet
                    type="text"
                   noTitle
                    placeholder="Invoice No, Client, Employee"
                    value={formData.Search || ""}
                    onChange={(value) => handleChange("Search", value)}
                    error={errors.Search}
                  />
                  <FormFieldSet
                    type="select"
                   noTitle
                    placeholder="Select Timesheets"
                    value={formData.Timesheets || ""}
                    // onChange={(value) => setActiveTab(value)}
                    onChange={(value) => handleChange("Timesheets", value)}
                    error={errors.Timesheets}
                    options={dropdowns}
                  />
                  <FormFieldSet
                    type="select"
                   noTitle
                    placeholder="Select Status"
                    value={formData.status || ""}
                    onChange={(value) => handleChange("status", value)}
                    error={errors.status}
                    options={""}
                    showSearch
                  />
              
                    <Button title="Search" onClick={handleSearch} />
             
             
                    <Button
                      title="QB Integration Profiles"
                      color="info"
                      onClick={() =>
                        navigate("/quickbooks/qb-integration-profile")
                      }
                    />
                
                  <div className="mt-5 flex items-center">
                    {selectedRowIds.length > 0 && (
                      <>
                        {/* <button
                          onClick={() => handleUpdate("customers")}
                          className="mx-1"
                        >
                          <Avatar src={qb} alt={"qb"} size="xs" outline />
                        </button>*/}
                      </>
                    )}
                  </div>
                </div>
              ),
            },
          ],
        }}
      />
    </div>
  );
};

export default Clients;
